import { useQuery } from '@tanstack/react-query'
import { httpsCallable } from 'firebase/functions'
import { functions, isDevMode } from '@/lib/firebase'

interface ExchangeRateResult {
  rate: number
  updatedAt: string
}

const DEV_RATE: ExchangeRateResult = { rate: 2800, updatedAt: new Date().toISOString() }

export function useExchangeRate() {
  return useQuery<ExchangeRateResult>({
    queryKey: ['exchangeRate'],
    queryFn: async () => {
      if (isDevMode()) return DEV_RATE
      const fn = httpsCallable<Record<string, never>, ExchangeRateResult>(functions, 'getExchangeRate')
      return (await fn({})).data
    },
    staleTime: 3_600_000,
    refetchInterval: isDevMode() ? false : 3_600_000,
  })
}
